import { get, map, join, isEmpty } from 'lodash/fp';
import columnsQueryToLabel from '../columnsToLabels';
import {
  NEW_BY_LABELS,
  REPORT_BY_LABELS,
  REPORT_AS_LABELS,
  RESULT_BY_LABELS
} from '../../../../helpers/constants';
import { toKeyValue } from '../../../../helpers/utils';

const getLabelsForOptionValues = (values, options) => {
  if (isEmpty(options)) return [];
  const labelsByValue = toKeyValue('value', 'label')(options);
  return map(value => get(value, labelsByValue), values);
};

const composeReadableSearchQuery = (
  query,
  locationOptions,
  trackingMethodOptions,
  columnsByType
) =>
  !isEmpty(query)
    ? {
        ...query,
        dateRange: join(' - ', query.dateRange),
        locations: getLabelsForOptionValues(query.locations, locationOptions),
        trackingMethods: getLabelsForOptionValues(
          query.trackingMethods,
          trackingMethodOptions
        ),
        groupBy: columnsQueryToLabel(query.groupBy, columnsByType),
        sumOrCountBy: columnsQueryToLabel(query.sumOrCountBy, columnsByType),
        firstTimeBy: NEW_BY_LABELS[query.firstTimeBy],
        reportType: REPORT_BY_LABELS[query.reportType],
        reportAs: REPORT_AS_LABELS[query.reportAs],
        resultBy: RESULT_BY_LABELS[query.resultBy]
      }
    : {};

export default composeReadableSearchQuery;
